export function formatOptionsData(id, label, data) {
  return (data || []).map((r) => ({
    label: r[label],
    value: r[id],
  }));
}

export function formatOptions2Map(id, label, data) {
  const obj = {};
  (data || []).forEach((item) => {
    obj[item[id]] = item[label];
  });
  return obj;
}

export function formatTreeData(childrenKey, data) {
  return data.map((r) => {
    r[childrenKey] && r[childrenKey].length > 0 && formatTreeData(childrenKey, r[childrenKey]);
    return {
      ...r,
      disabled: true,
    };
  });
}

